/**
 *
 * IMPORTANT:
 * This file is used both in vue2 and vue3 project
 * Dont use vue syntax and the store conept
 * FOr clarifications contact Leela
 *
 */

export const SET_QUICKSTART_OVERLAY = 'quick start overlay setting';
export const SET_SHOW_REGISTRATION_MODAL = 'registration modal setting';
export const SET_REGISTRATION_MODAL_STEP = 'registration modal step setting';
export const SET_OPEN_TVM_HELP_MODAL = 'open tvm help modal';
export const SET_OPEN_TVM_NAVIGATE_TILE = 'open tvm navigate tile';
export const SET_CHAT_THEME_SETTINGS = 'set chat theme settings';
export const SET_CHAT_ACTIONS = 'set chat actions';
export const SET_OLD_TID = 'set old tid';
export const SET_VDP_VEHICLE_DETAILS = 'set vdp vehicle details';
export const SET_MOBILE_NAVIGATION_DETAILS = 'set mobile navigation details';
export const SET_SUBARU_OEM_PROGRAM_CODES = 'set subaru oem program codes';
export const SET_MENU_SECTION_SETTINGS = 'set menu section settings';
export const SET_IFRAME_MODAL_POPUP_DETAILS = '[link click iframe modal popup] Set the iframe popup modal data upon clicking on link where link contain #modal-[modelName]';
export const SET_OPEN_OTP_DETAILS_MODAL = 'set open otp details modal';
export const SET_OTP_MODAL_DATA = 'set otp modal data';
